import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Youtube } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export function YouTubeControl({ authHeaders }) {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/api/settings/youtube`)
      .then((r) => setUrl(r.data.url || ''))
      .catch(() => {});
  }, []);

  const save = async (value) => {
    setBusy(true);
    try {
      await axios.post(`${API}/api/settings/youtube`, { url: value }, { headers: authHeaders() });
      setUrl(value);
      toast.success(value ? 'YouTube live link set ஆயிடுச்சு — home page-la video வரும்' : 'YouTube live remove ஆயிடுச்சு');
    } catch {
      toast.error('Save failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-8 border border-white/10 bg-black/30 p-5" data-testid="youtube-control">
      <div className="mb-3 flex items-center gap-2">
        <Youtube className="h-4 w-4 text-[#D8232A]" />
        <h2 className="font-display text-sm uppercase tracking-[0.2em] text-[#F5C542]">
          YouTube Live Link
        </h2>
      </div>
      <div className="flex flex-wrap gap-2">
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://www.youtube.com/live/XXXX illa watch?v=XXXX link paste பண்ணுங்க"
          data-testid="youtube-url-input"
          className="min-w-0 flex-1 border border-white/15 bg-black/60 px-3 py-2.5 text-sm text-white outline-none focus:border-[#F5C542]"
        />
        <button
          type="button"
          onClick={() => save(url.trim())}
          disabled={busy}
          data-testid="youtube-save-btn"
          className="bg-[#F5C542] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-black hover:bg-[#FFDD75] disabled:opacity-50"
        >
          Set Live
        </button>
        <button
          type="button"
          onClick={() => save('')}
          disabled={busy}
          data-testid="youtube-clear-btn"
          className="border border-red-500/50 px-5 py-2.5 text-xs uppercase tracking-[0.2em] text-red-400 hover:bg-red-500/10 disabled:opacity-50"
        >
          Stop
        </button>
      </div>
      <p className="mt-2 text-[11px] text-[#666]">
        Link set பண்ணா home page-la LIVE video player வரும். Stream முடிஞ்சதும் Stop அழுத்துங்க.
      </p>
    </div>
  );
}
